export default {
    mounted() {
        let editor = this.$refs.editor;

        if (editor) {
            (editor.querySelector('select.ql-header') || {}).ariaLabel = "Select a text format";
            (editor.querySelector('.ql-picker-label') || {}).ariaLabel = "Select a header format";
            (editor.querySelector('.ql-bold') || {}).ariaLabel = "Format bold";
            (editor.querySelector('.ql-italic') || {}).ariaLabel = "Format italic";
            (editor.querySelector('.ql-underline') || {}).ariaLabel = "Format underline";
            (editor.querySelector('.ql-blockquote') || {}).ariaLabel = "Format blockquote";
            (editor.querySelector('.ql-align') || {}).ariaLabel = "Format left align";
            (editor.querySelector('.ql-align[value="center"]') || {}).ariaLabel = "Format center align";
            (editor.querySelector('.ql-align[value="right"]') || {}).ariaLabel = "Format right align";
            (editor.querySelector('.ql-list[value="ordered"]') || {}).ariaLabel = "Format ordered list";
            (editor.querySelector('.ql-list[value="bullet"]') || {}).ariaLabel = "Format bulleted list";
            (editor.querySelector('.ql-indent[value="+1"]') || {}).ariaLabel = "Format indent";
            (editor.querySelector('.ql-indent[value="-1"]') || {}).ariaLabel = "Format outdent";
            (editor.querySelector('.ql-color .ql-picker-label') || {}).ariaLabel = "Format text color";
            (editor.querySelector('.ql-background .ql-picker-label') || {}).ariaLabel = "Format background color";
            (editor.querySelector('.ql-clean') || {}).ariaLabel = "Remove formatting";
        }
    },
}
